import {
  Box
} from "@mui/material";
import React from "react";

const SubscriptionByProduct = () => {
  return (
    <>
      <Box sx={{ backgroundColor: "background.default" }} p={1}>
        <h2>SubscriptionByProduct</h2>
      </Box>
    </>
  );
};

export default SubscriptionByProduct;
